import { makeRequest } from 'src/utils/graphql';
import {
  PagesActions,
  HomePageEntity,
  PageEntity,
  MarketingPageEntity,
  CareerPageEntity,
} from 'src/modules/pages';
import { ArticleEntity } from 'src/modules/articles';
import { QUERY_PAGE } from '../queries';
import { QUERY_HOMEPAGE } from '../components/homepage/queries';
import { QUERY_MARKETING_PAGE } from '../components/marketing/queries';
import { QUERY_CAREERS_PAGE } from 'src/modules/jobs/listing/queries';
import { DocumentNode } from 'graphql';

export const fetchPageDataSSG = async (key: string, query?: DocumentNode) => {
  let makeRequestArgs: [DocumentNode, Record<string, string>?];

  if (query) {
    makeRequestArgs = [query];
  } else {
    makeRequestArgs = [QUERY_PAGE, { key }];
  }

  const response = await makeRequest<{
    homepage?: HomePageEntity;
    career?: CareerPageEntity;
    pages?: PageEntity[];
    articles?: ArticleEntity[];
  }>(...makeRequestArgs);

  return response;
};

export const fetchPageData = (key: string, query?: DocumentNode) => {
  return async (dispatch, getState) => {
    dispatch(fetchPageDataBegin());

    try {
      let makeRequestArgs: [DocumentNode, Record<string, string>?];
      const { pages: pagesState } = getState().pages;
      if (pagesState[key]) {
        dispatch(fetchPageDataSuccess({ currentPageKey: key }));
        return null;
      }
      if (query) {
        makeRequestArgs = [query];
      } else {
        makeRequestArgs = [QUERY_PAGE, { key }];
      }
      const response = await makeRequest<{
        homepage?: HomePageEntity;
        career?: CareerPageEntity;
        pages?: PageEntity[];
        articles?: ArticleEntity[];
      }>(...makeRequestArgs);

      let page;
      if (response.homepage) {
        page = { ...response.homepage, articles: response.articles };
      } else if (response.career) {
        page = response.career;
      } else {
        page = response.pages?.length ? response.pages[0] : null;
      }

      dispatch(fetchPageDataSuccess({ pages: { [key]: page }, currentPageKey: key }));

      return response;
    } catch (e) {
      console.error(e);
      dispatch(fetchPageDataError({ message: e.message, currentPageKey: key }));

      return null;
    }
  };
};

export const fetchHomePageData = async () => {
  try {
    const response = await makeRequest<{
      homepage?: HomePageEntity;
    }>(QUERY_HOMEPAGE);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const fetchCareersPageData = async () => {
  try {
    const response = await makeRequest<{
      homepage?: HomePageEntity;
      career?: CareerPageEntity;
      pages?: PageEntity[];
      articles?: ArticleEntity[];
    }>(QUERY_CAREERS_PAGE);

    return response;
  } catch (e) {
    console.error(e);
    return null;
  }
};

export const fetchMarketingPage = async (slug, dispatch, outputChannel) => {
  dispatch(fetchMarketingPageDataBegin());

  try {
    const response = await makeRequest<{
      marketingPages?: MarketingPageEntity;
    }>(QUERY_MARKETING_PAGE, { slug, outputChannel });

    dispatch(fetchMarketingPageDataSuccess(response.marketingPages[0]));

    return response;
  } catch (e) {
    console.error(e);
    dispatch(fetchMarketingPageDataError({ message: e.message }));

    return null;
  }
};

/*
 * Pages
 */
const fetchPageDataBegin = () => ({
  type: PagesActions.FetchPageBegin,
});

const fetchPageDataSuccess = (result) => ({
  type: PagesActions.FetchPageSuccess,
  payload: result,
});

const fetchPageDataError = (error) => ({
  type: PagesActions.FetchPageError,
  payload: { error },
});

/*
 * Marketing Pages
 */
const fetchMarketingPageDataBegin = () => ({
  type: PagesActions.FetchMarketingPageBegin,
});
const fetchMarketingPageDataSuccess = (result) => ({
  type: PagesActions.FetchMarketingPageSuccess,
  payload: result,
});
const fetchMarketingPageDataError = (error) => ({
  type: PagesActions.FetchMarketingPageError,
  payload: { error },
});
